import React from 'react';
import {
  Card,
  CardBody,
  Col,
  Row,
  FormGroup,
  Label,
  Input,
  Collapse,
  Button,
  Badge
} from 'reactstrap';

import Styles from './EvidenceOfInsuranceform.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import AddressHelper from '@src/components/Elements/AddressHelper/AddressHelper';
import EvidenceOfInsuranceModal from '@components/EvidenceOfInsurance/EvidenceOfInsuranceModal/EvidenceOfInsuranceModal';
import EvidenceOfInsuranceDateModal from '@components/EvidenceOfInsurance/EvidenceOfInsuranceDateModal/EvidenceOfInsuranceDateModal';

import moment from 'moment';
import MailingAddress from '@src/components/Associations/UnitView/MailingAddress/MailingAddress';
import MailingAddressModal from '@src/components/Associations/UnitView/MailingAddress/MailingAddressModal/MailingAddressModal';
import PolicyView from '@src/components/Associations/AssociationView/Policies/PolicyView/PolicyView';
import Activities from '@components/Elements/Activites/Activities';

import GeneralOptions from './GeneralOptions/GeneralOptions';
import ContactInformation from './ContactInformation/ContactInformation';
import ContactInformationModal from './ContactInformation/ContactInformationModal';
import BillingOptionsModal from './BillingOptionsModal/BillingOptionsModal';
import BillingOptionsCognitoModal from './BillingOptionsModal/BillingOptionsCognitoModal';
import BillingOptions from './BillingOptions/BillingOptions';
import BillingOptionsCognito from './BillingOptions/BillingOptionsCognito';
import ReferrenceNumberModal from './ReferrenceNumberModal/ReferrenceNumberModal';
import TypeModal from './TypeModal/TypeModal';
import ConfirmModal from '@src/components/ConfirmModal/ConfirmModal';
import Mortgages from '@src/components/Associations/UnitView/Mortgages/Mortgages';
import MortgagesModal from '@src/components/Associations/UnitView/Mortgages/MortgagesModal/MortgagesModal';
import CognitoMortgagesModal from './CognitoMortgagesModal/CognitoMortgagesModal';
import axiosInstance from '@src/axios-instance';
import HomeownersModal from '@components/Associations/UnitView/Homeowners/HomeownersModal/HomeownersModal';

import AssignAssociationModal from './AssignAssociationModal/AssignAssociationModal';
import AssignUnitModal from './AssignUnitModal/AssignUnitModal';

class EvidenceOfInsuranceForm extends React.Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      remarksCollapse: false,
      secondMortgageCollapse: false,
      thirdMortgageCollapse: false,
      companyCollapse: false,
      editInformationModal: false,
      editTypeModal: false,
      billingOptionsModal: false,
      editMortgagesModal: false,
      editCognitoMortgagesModal: false,
      remarks: false,
      notes: false,
      editMailingAddressModal: false,
      associationModal: false,
      editHomeownersModal: false,
      confirmModalActive: false,
      editEffectiveDate: false,
      editExpirationDate: false
    };
    this.toggleModal = this.toggleModal.bind(this);
    this.toggleInput = this.toggleInput.bind(this);
  }

  toggleModal = modalType => {
    this.setState(prevState => ({
      [modalType]: !prevState[modalType]
    }));
  };

  toggleInput(input) {
    const current = this.state[input];
    this.setState({
      [input]: !current
    });
    if (!current) {
      setTimeout(() => {
        document.getElementsByClassName(input)[0].focus();
      }, 200);
    }
  }

  toggle(collapseItem, e) {
    this.setState(state => ({ [collapseItem]: !state[collapseItem] }));
  }

  onUpdate = (postData, callback, modalType) => {
    this.props.setLoader(true);
    axiosInstance()
      .put(`/evidence-of-insurances/${this.props.entity.id}.json`, postData)
      .then(response => {
        if (modalType !== undefined) {
          this.toggleModal(modalType);
        }
        callback();
        this.props.getEntity();
      })
      .catch(err => {});
  };

  render = () => {
    const { entity } = this.props;
    const { unit, association } = entity;

    const activeSet =
      association !== null && association.master_policy_sets !== undefined
        ? association.master_policy_sets.filter(
            item => item.status === 'active'
          )
        : [];
    const activePolicies = activeSet.length > 0 ? activeSet[0] : {};

    const futureSet =
      association !== null && association.master_policy_sets !== undefined
        ? association.master_policy_sets.filter(
            item => item.status === 'pending'
          )
        : [];
    const futurePolicies = futureSet.length > 0 ? futureSet[0] : {};

    const issueDate = moment(entity.issue_date * 1000).format('MM/DD/YYYY');

    const isCognito = entity.evidence_of_insurance_form !== null;
    return (
      <React.Fragment>
        {/* Notes */}
        <Row className={'mt-3 ' + Styles['form-container']}>
          <Col>
            <Card className={'h-100'}>
              <CardBody>
                <div className={'font-md color-blue'}>
                  <span className={'text-capitalize'}>
                    Notes (Internal Only)
                  </span>
                </div>

                <Row
                  onClick={() => this.toggleInput('notes')}
                  className={'pointer'}
                >
                  <Col>
                    {!this.state.notes && !this.props.loading ? (
                      <div className={'pt-2 content'}>{entity.notes}</div>
                    ) : (
                      <textarea
                        className={'notes form-control'}
                        onBlur={e => {
                          this.props.saveEntity(
                            {
                              notes: e.currentTarget.value
                            },
                            () => this.toggleInput('notes')
                          );
                        }}
                        defaultValue={entity.notes}
                        maxLength={2000}
                      />
                    )}
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row className={'mt-3 ' + Styles['form-container']}>
          <Col>
            <GeneralOptions
              issueDate={issueDate}
              onClick={() => this.toggleModal('editInformationModal')}
              onTypeClick={() => this.toggleModal('editTypeModal')}
              onClickRefNumber={() => this.toggleModal('editReferenceNumber')}
              onClickEffectiveDate={() => this.toggleModal('editEffectiveDate')}
              onClickExpirationDate={() =>
                this.toggleModal('editExpirationDate')
              }
              entity={entity}
              getEntity={this.props.getEntity}
              saveEntity={data => this.props.saveEntity(data)}
            />
          </Col>
          <Col>
            {entity.evidence_of_insurance_form === null ? (
              <BillingOptions
                entity={entity}
                toggleModal={() => this.toggleModal('billingOptionsModal')}
                createInvoice={() => this.toggleModal('confirmModalActive')}
                getInvoicePDF={this.props.getInvoicePdf}
                sendQBInvoice={this.props.sendQBInvoice}
              />
            ) : (
              <BillingOptionsCognito
                entity={entity}
                toggleModal={() =>
                  this.toggleModal('billingOptionsCognitoModal')
                }
                createInvoice={() => this.toggleModal('confirmModalActive')}
                getInvoicePDF={this.props.getInvoicePdf}
                sendQBInvoice={this.props.sendQBInvoice}
              />
            )}
          </Col>
        </Row>
        <Row className={'mt-3 ' + Styles['form-container']}>
          <Col>
            <Card className={'h-100'}>
              <CardBody>
                <div className={'font-md color-blue'}>
                  <span className={'text-capitalize'}>Insured</span>
                  {association === null && (
                    <React.Fragment>
                      <Badge color={'danger font-sm ml-2'}>
                        No Association Found
                      </Badge>
                      <Button
                        color={'link'}
                        onClick={() => this.toggleModal('associationModal')}
                      >
                        Assign Association
                      </Button>
                    </React.Fragment>
                  )}
                  {association !== null && (
                    <React.Fragment>
                      {association.status === 1 ? (
                        <Badge color={'success'} className={'ml-2'}>
                          Active
                        </Badge>
                      ) : (
                        <Badge color={'danger'} className={'ml-2'}>
                          Inactive
                        </Badge>
                      )}
                    </React.Fragment>
                  )}
                  {association !== null &&
                    entity.evidence_of_insurance_form !== null && (
                      <React.Fragment>
                        {association.common_area_only === true && (
                          <Badge
                            color={'warning'}
                            className={
                              'font-xs ml-2 d-inline-block position-relative'
                            }
                          >
                            Common Area Only - No EOIs.
                          </Badge>
                        )}
                        <Button
                          color={'link'}
                          onClick={() => this.toggleModal('associationModal')}
                        >
                          Edit
                        </Button>
                      </React.Fragment>
                    )}
                </div>
                <div className={'pt-2 content'}>
                  {association !== null ? (
                    <React.Fragment>
                      <Link to={`/associations/${association.id}`}>
                        {association.name}
                      </Link>
                      <br />
                      {association.management_company_id !== null &&
                      association.management_company_id !== '' ? (
                        <React.Fragment>
                          <Link
                            to={`/management-companies/${association.management_company_id}`}
                          >
                            {association.management_company.name}
                          </Link>
                          <br />
                          <AddressHelper
                            {...association.management_company}
                            twoLines={true}
                          />
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <AddressHelper {...association} twoLines={true} />
                        </React.Fragment>
                      )}
                    </React.Fragment>
                  ) : (
                    <React.Fragment>{entity.association_name}</React.Fragment>
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>

          {/* General Information */}
          {entity.master_cert_only === 0 && (
            <Col>
              <Card className={'h-100'}>
                <CardBody>
                  <div className={'font-md color-blue'}>
                    <span className={'text-capitalize'}>
                      Property & Homeowner
                      {unit === null && (
                        <Badge color={'danger font-sm ml-2'}>
                          No Unit Found
                        </Badge>
                      )}
                      {association !== null &&
                        entity.evidence_of_insurance_form !== null && (
                          <React.Fragment>
                            <Button
                              color={'link'}
                              onClick={() => this.toggleModal('unitModal')}
                            >
                              {unit === null ? 'Assign Unit' : 'Edit'}
                            </Button>
                          </React.Fragment>
                        )}
                    </span>
                  </div>
                  <div className={'pt-2 content'}>
                    {entity.owner_first_name !== null && (
                      <div>
                        {`${entity.owner_first_name} ${entity.owner_last_name}`}{' '}
                        {entity.second_owner_first_name.length > 0 && (
                          <span>
                            and{' '}
                            {`${entity.second_owner_first_name} ${entity.second_owner_last_name}`}
                          </span>
                        )}
                        <br />
                        {entity.vesting_1}
                      </div>
                    )}
                    {entity.third_owner !== null &&
                      entity.third_owner.length > 0 && (
                        <div className={'pt-2'}>
                          {`${entity.third_owner_first_name} ${entity.third_owner_last_name}`}{' '}
                          {entity.fourth_owner.length > 0 && (
                            <span>
                              and{' '}
                              {`${entity.fourth_owner_first_name} ${entity.fourth_owner_last_name}`}
                            </span>
                          )}
                          <br />
                          {entity.vesting_2}
                        </div>
                      )}
                    <Button
                      color={'link'}
                      className={'px-0 m-0 mb-2'}
                      onClick={() => this.toggleModal('editHomeownersModal')}
                    >
                      Edit Homeowner Information
                    </Button>
                    <br />
                    {unit !== null ? (
                      <React.Fragment>
                        <Link to={`/units/${unit.id}`}>
                          {unit.address_no} {unit.street}
                          {unit.unit_no !== null &&
                            unit.unit_no.length > 0 &&
                            `, #${unit.unit_no}`}
                        </Link>
                        <br />
                        <AddressHelper
                          {...unit}
                          address_line_1={null}
                          address_line_2={null}
                        />
                      </React.Fragment>
                    ) : (
                      <AddressHelper
                        city={
                          entity.evidence_of_insurance_form
                            .property_address_city
                        }
                        state={
                          entity.evidence_of_insurance_form
                            .property_address_state
                        }
                        zip_code={
                          entity.evidence_of_insurance_form
                            .property_address_postal_code
                        }
                        address_line_1={
                          entity.evidence_of_insurance_form
                            .property_address_line_1
                        }
                        address_line_2={
                          entity.evidence_of_insurance_form
                            .property_address_line_2
                        }
                      />
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          )}
        </Row>
        {/* MORTGAGE */}
        {entity.master_cert_only === 0 && (
          <Row className={'mt-3 ' + Styles['form-container']}>
            <Col>
              <Mortgages
                entity={entity}
                toggle={() => this.toggleModal('editMortgagesModal')}
                toggleCognito={() =>
                  this.toggleModal('editCognitoMortgagesModal')
                }
              />
            </Col>
            <Col>
              <Card className={'h-100'}>
                <CardBody>
                  <div className={'font-md color-blue'}>
                    <span className={'text-capitalize'}>Mortgage Clause</span>
                  </div>
                  <div className={'pt-2 content'}>
                    <FormGroup check className={'pb-1'}>
                      <Label check>
                        <Input
                          type="checkbox"
                          checked={entity.is_additional_insured === 1}
                          onChange={e =>
                            this.onUpdate(
                              {
                                is_additional_insured: e.currentTarget.checked
                                  ? 1
                                  : 0
                              },
                              () => this.props.setLoader(false)
                            )
                          }
                        />{' '}
                        Additional Insured
                      </Label>
                    </FormGroup>
                    <FormGroup check className={'pb-1'}>
                      <Label check>
                        <Input
                          type="checkbox"
                          checked={entity.is_lenders_loss_payable === 1}
                          onChange={e =>
                            this.onUpdate(
                              {
                                is_lenders_loss_payable: e.currentTarget.checked
                                  ? 1
                                  : 0
                              },
                              () => this.props.setLoader(false)
                            )
                          }
                        />{' '}
                        Lender's Loss Payble
                      </Label>
                    </FormGroup>
                    <FormGroup check className={'pb-1'}>
                      <Label check>
                        <Input
                          type="checkbox"
                          checked={entity.is_loss_payee === 1}
                          onChange={e =>
                            this.onUpdate(
                              {
                                is_loss_payee: e.currentTarget.checked ? 1 : 0
                              },
                              () => this.props.setLoader(false)
                            )
                          }
                        />{' '}
                        Loss Payee
                      </Label>
                    </FormGroup>
                    <FormGroup check className={'pb-1'}>
                      <Label check>
                        <Input
                          type="checkbox"
                          checked={entity.is_mortgagee === 1}
                          onChange={e =>
                            this.onUpdate(
                              {
                                is_mortgagee: e.currentTarget.checked ? 1 : 0
                              },
                              () => this.props.setLoader(false)
                            )
                          }
                        />{' '}
                        Mortgagee
                      </Label>
                    </FormGroup>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
        {/* Company & Coverage Information */}
        <Row className={'mt-3 ' + Styles['form-container']}>
          <Col>
            <Card className={'h-100'}>
              <CardBody>
                <div className={'font-md color-blue'}>
                  <span className={'text-capitalize'}>
                    Company & Coverage Information
                  </span>
                  <button
                    onClick={e => this.toggle('companyCollapse', e)}
                    className={'float-right'}
                  >
                    {!this.state.companyCollapse ? (
                      <span>
                        Expand&nbsp;&nbsp;
                        <FontAwesomeIcon icon={['fas', 'chevron-down']} />
                      </span>
                    ) : (
                      <span>
                        Collapse&nbsp;&nbsp;
                        <FontAwesomeIcon icon={['fas', 'chevron-up']} />
                      </span>
                    )}
                  </button>
                </div>

                <FormGroup check className={'pb-3 pt-2'}>
                  <Label check>
                    <Input
                      style={{ top: '5px' }}
                      type="checkbox"
                      checked={entity.include_renewal === 1}
                      disabled={futurePolicies.id === undefined}
                      onChange={e =>
                        this.props.saveEntity({
                          include_renewal: e.currentTarget.checked ? 1 : 0
                        })
                      }
                    />{' '}
                    Include these renewal policies in the EOI
                  </Label>
                </FormGroup>
                <Collapse isOpen={this.state.companyCollapse}>
                  <div className={'pt-2 content'}>
                    {activePolicies.id !== undefined && (
                      <React.Fragment>
                        <Row>
                          <Col>
                            <FormGroup
                              check
                              className={'pb-3 pt-2 float-left mr-3'}
                            >
                              <Label check>
                                <Input
                                  style={{ top: '5px' }}
                                  type="checkbox"
                                  checked={activePolicies.perils_insured === 1}
                                  readOnly={true}
                                />{' '}
                                Perils Insured (All Risk)
                              </Label>
                            </FormGroup>
                            <FormGroup
                              check
                              className={'pb-3 pt-2 float-left mr-3'}
                            >
                              <Label check>
                                <Input
                                  style={{ top: '5px' }}
                                  type="checkbox"
                                  checked={activePolicies.basic_form === 1}
                                  readOnly={true}
                                />{' '}
                                Basic Form
                              </Label>
                            </FormGroup>
                            <FormGroup
                              check
                              className={'pb-3 pt-2 float-left mr-3'}
                            >
                              <Label check>
                                <Input
                                  style={{ top: '5px' }}
                                  type="checkbox"
                                  checked={activePolicies.broad_form === 1}
                                  readOnly={true}
                                />{' '}
                                Broad Form
                              </Label>
                            </FormGroup>
                            <FormGroup check className={'pb-3 pt-2 float-left'}>
                              <Label check>
                                <Input
                                  style={{ top: '5px' }}
                                  type="checkbox"
                                  checked={activePolicies.special_form === 1}
                                  readOnly={true}
                                />{' '}
                                Special Form
                              </Label>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12}>
                            <ol type={'A'}>
                              {activePolicies.master_policies.map(item => (
                                <li key={`eoi-policy-${item.id}`}>
                                  <PolicyView entity={item} />
                                </li>
                              ))}
                            </ol>
                          </Col>
                        </Row>
                      </React.Fragment>
                    )}

                    {futurePolicies.id !== undefined && (
                      <React.Fragment>
                        <hr className={'my-4'} />
                        <Row>
                          <Col>
                            <h3>Coming Year (Renewal)</h3>
                          </Col>
                        </Row>
                        {futurePolicies.master_policies.length > 0 && (
                          <React.Fragment>
                            <Row>
                              <Col>
                                <FormGroup
                                  check
                                  className={'pb-3 pt-2 float-left mr-3'}
                                >
                                  <Label check>
                                    <Input
                                      style={{ top: '5px' }}
                                      type="checkbox"
                                      checked={
                                        futurePolicies.perils_insured === 1
                                      }
                                      readOnly={true}
                                    />{' '}
                                    Perils Insured (All Risk)
                                  </Label>
                                </FormGroup>
                                <FormGroup
                                  check
                                  className={'pb-3 pt-2 float-left mr-3'}
                                >
                                  <Label check>
                                    <Input
                                      style={{ top: '5px' }}
                                      type="checkbox"
                                      checked={futurePolicies.basic_form === 1}
                                      readOnly={true}
                                    />{' '}
                                    Basic Form
                                  </Label>
                                </FormGroup>
                                <FormGroup
                                  check
                                  className={'pb-3 pt-2 float-left mr-3'}
                                >
                                  <Label check>
                                    <Input
                                      style={{ top: '5px' }}
                                      type="checkbox"
                                      checked={futurePolicies.broad_form === 1}
                                      readOnly={true}
                                    />{' '}
                                    Broad Form
                                  </Label>
                                </FormGroup>
                                <FormGroup
                                  check
                                  className={'pb-3 pt-2 float-left'}
                                >
                                  <Label check>
                                    <Input
                                      style={{ top: '5px' }}
                                      type="checkbox"
                                      checked={
                                        futurePolicies.special_form === 1
                                      }
                                      readOnly={true}
                                    />{' '}
                                    Special Form
                                  </Label>
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col xs={12}>
                                <ol type={'A'}>
                                  {futurePolicies.master_policies.map(item => (
                                    <li key={`eoi-policy-${item.id}`}>
                                      <PolicyView entity={item} />
                                    </li>
                                  ))}
                                </ol>
                              </Col>
                            </Row>
                          </React.Fragment>
                        )}
                      </React.Fragment>
                    )}
                  </div>
                </Collapse>
              </CardBody>
            </Card>
          </Col>
        </Row>
        {/* Remarks */}
        <Row className={'mt-3 ' + Styles['form-container']}>
          <Col>
            <Card className={'h-100'}>
              <CardBody>
                <div className={'font-md color-blue'}>
                  <span className={'text-capitalize'}>Remarks</span>
                  <button
                    onClick={e => this.toggle('remarksCollapse', e)}
                    className={'float-right'}
                  >
                    {!this.state.remarksCollapse ? (
                      <span>
                        Expand&nbsp;&nbsp;
                        <FontAwesomeIcon icon={['fas', 'chevron-down']} />
                      </span>
                    ) : (
                      <span>
                        Collapse&nbsp;&nbsp;
                        <FontAwesomeIcon icon={['fas', 'chevron-up']} />
                      </span>
                    )}
                  </button>
                </div>
                <Collapse isOpen={this.state.remarksCollapse}>
                  <Row
                    onClick={e => {
                      if (e.target.nodeName !== 'TEXTAREA') {
                        this.toggleInput('remarks');
                      }
                    }}
                    className={'pointer'}
                  >
                    <Col>
                      <div className={'pt-2 content'}>
                        {entity.association !== null
                          ? entity.association.remarks
                          : ''}
                      </div>
                    </Col>
                  </Row>
                </Collapse>
              </CardBody>
            </Card>
          </Col>
        </Row>
        {/* Recepient */}
        {entity.master_cert_only === 0 && (
          <div className={'mt-3'}>
            {isCognito ? (
              <ContactInformation
                entity={entity.evidence_of_insurance_form}
                toggle={() => this.toggleModal('contactInformationModal')}
              />
            ) : (
              <MailingAddress
                entity={entity}
                toggle={() => this.toggleModal('editMailingAddressModal')}
                title={'Borrower Contact Information'}
              />
            )}
          </div>
        )}
        {/* History */}
        <Row className={'mt-3 ' + Styles['form-container']}>
          <Col>
            <Card className={'h-100'}>
              <CardBody>
                <div className={'font-md color-blue'}>
                  <span className={'text-capitalize'}>History</span>
                </div>

                <Activities activities={entity.activities} />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <MailingAddressModal
          entity={entity}
          isActive={this.state.editMailingAddressModal}
          toggle={() => this.toggleModal('editMailingAddressModal')}
          onSubmit={postData =>
            this.onUpdate(
              postData,
              () => this.props.setLoader(false),
              'editMailingAddressModal'
            )
          }
          errorUnit={this.state.errorUnit}
        />
        {this.state.billingOptionsModal && (
          <BillingOptionsModal
            entity={entity}
            isActive={this.state.billingOptionsModal}
            toggle={() => this.toggleModal('billingOptionsModal')}
            saveEntity={this.props.saveEntity}
          />
        )}
        {this.state.billingOptionsCognitoModal && (
          <BillingOptionsCognitoModal
            entity={entity}
            isActive={this.state.billingOptionsCognitoModal}
            toggle={() => this.toggleModal('billingOptionsCognitoModal')}
            saveEntity={this.props.saveEntity}
          />
        )}
        <EvidenceOfInsuranceModal
          entity={entity}
          edit={true}
          issueDate={moment(entity.issue_date * 1000)}
          isActive={this.state.editInformationModal}
          toggle={() => this.toggleModal('editInformationModal')}
          history={this.props.history}
          saveEntity={this.props.saveEntity}
          loader={this.props.setLoader}
        />
        <ReferrenceNumberModal
          entity={entity}
          loader={this.props.setLoader}
          isActive={this.state.editReferenceNumber}
          edit={true}
          header={'Edit Reference Number'}
          toggle={() => this.toggleModal('editReferenceNumber')}
          history={this.props.history}
          saveEntity={this.props.saveEntity}
        />

        <TypeModal
          entity={entity}
          loader={this.props.setLoader}
          isActive={this.state.editTypeModal}
          edit={true}
          header={'Edit EOI Type'}
          toggle={() => this.toggleModal('editTypeModal')}
          history={this.props.history}
          saveEntity={this.props.saveEntity}
        />

        {(this.state.editEffectiveDate || this.state.editExpirationDate) && (
          <EvidenceOfInsuranceDateModal
            entity={entity}
            edit={true}
            loader={this.props.setLoader}
            isActive={
              this.state.editEffectiveDate || this.state.editExpirationDate
            }
            editType={this.state.editEffectiveDate ? 'effective' : 'expiration'}
            editDate={
              this.state.editEffectiveDate
                ? entity.effective_date
                : entity.expiration_date
            }
            header={
              this.state.editEffectiveDate
                ? 'Edit Effective Date'
                : 'Edit Expiration Date'
            }
            toggle={
              this.state.editEffectiveDate
                ? () => this.toggleModal('editEffectiveDate')
                : () => this.toggleModal('editExpirationDate')
            }
            history={this.props.history}
            saveEntity={this.props.saveEntity}
          />
        )}
        <ConfirmModal
          isActive={this.state.confirmModalActive}
          toggle={() => this.toggle('confirmModalActive')}
          title={'Confirmation'}
          body={
            'Would you like to create an invoice on QuickBooks online for this EOI Request?'
          }
          confirmLabel={'Yes, Create the Invoice'}
          confirmAction={() =>
            this.props.createInvoice(() => this.toggle('confirmModalActive'))
          }
        />
        <HomeownersModal
          entity={entity}
          isActive={this.state.editHomeownersModal}
          toggle={() => this.toggleModal('editHomeownersModal')}
          onSubmit={(postData, callback) =>
            this.onUpdate(
              postData,
              () => this.props.setLoader(false),
              'editHomeownersModal'
            )
          }
          errorUnit={this.state.errorUnit}
        />
        {this.state.editMortgagesModal && (
          <MortgagesModal
            entity={entity}
            isActive={this.state.editMortgagesModal}
            toggle={() => this.toggleModal('editMortgagesModal')}
            onSubmit={postData =>
              this.onUpdate(
                postData,
                () => this.props.setLoader(false),
                'editMortgagesModal'
              )
            }
            errorUnit={this.state.errorUnit}
          />
        )}
        {this.state.editCognitoMortgagesModal && (
          <CognitoMortgagesModal
            entity={entity}
            isActive={this.state.editCognitoMortgagesModal}
            toggle={() => this.toggleModal('editCognitoMortgagesModal')}
            onSubmit={postData =>
              this.onUpdate(
                postData,
                () => this.props.setLoader(false),
                'editCognitoMortgagesModal'
              )
            }
            errorUnit={this.state.errorUnit}
          />
        )}
        {this.state.contactInformationModal && (
          <ContactInformationModal
            entity={entity.evidence_of_insurance_form}
            isActive={this.state.contactInformationModal}
            toggle={() => this.toggleModal('contactInformationModal')}
            onSubmit={postData =>
              this.onUpdate(
                postData,
                () => this.props.setLoader(false),
                'contactInformationModal'
              )
            }
            errorUnit={this.state.errorUnit}
          />
        )}

        {this.state.associationModal && (
          <AssignAssociationModal
            entity={entity}
            isActive={this.state.associationModal}
            toggle={() => this.toggleModal('associationModal')}
            saveEntity={this.props.saveEntity}
          />
        )}

        {this.state.unitModal && (
          <AssignUnitModal
            entity={entity}
            isActive={this.state.unitModal}
            toggle={() => this.toggleModal('unitModal')}
            saveEntity={this.props.saveEntity}
          />
        )}
      </React.Fragment>
    );
  };
}

export default EvidenceOfInsuranceForm;
